import { colors } from '../../colors';
var pagination = {
  activeColor: colors.dustyTeal,
  defaultColor: colors.charcoalGrey
};
export default pagination;